<template lang="pug">
.input-text-field-vertical(ref='inputField', :style='setStyle')
  .input-text-field-vertical__display
    .input-text-field-vertical__display__text-before(v-if='beforeText') {{ beforeText }}
    .input-text-field-vertical__display__value(ref='displayValue', @click='showPopup') {{ inputValue }}
    .input-text-field-vertical__display__text-after(v-if='afterText') {{ afterText }}
  .input-text-field-vertical__popup(:data-show='isShowPopup')
    .input-text-field-vertical__popup__background(@click='hidePopup')
    .input-text-field-vertical__popup__body(:data-side='sidePosition')
      .input-text-field-vertical__popup__body__text-before(v-if='beforeText') {{ beforeText }}
      text-field-study.input-text-field-vertical__popup__body__input(
        ref='textFieldStudy',
        v-model='inputValue',
        :maxWidth='maxWidth'
      )
      .input-text-field-vertical__popup__body__text-after(v-if='afterText') {{ afterText }}
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import TextFieldStudy from '@/components/molecules/student/TextFieldStudy.vue'

type side = 'left' | 'right'

@Component({
  components: {
    TextFieldStudy,
  },
})
export default class InputTextFieldVertical extends Vue {
  // 入力欄の最大幅
  private maxWidth = 0
  private isShowPopup = false
  private sidePosition: side = 'left'
  private topDistance = 0
  private sideDistance = 0

  // 入力値
  @Prop()
  value!: string

  // 前方テキスト
  @Prop()
  beforeText?: string

  // 後方テキスト
  @Prop()
  afterText?: string

  // テキスト入力要素Ref
  @Ref() inputField!: HTMLElement

  // テキストフィールドref
  @Ref() textFieldStudy!: TextFieldStudy

  // 入力内容表示部ref
  @Ref() displayValue!: HTMLElement

  // 入力値ゲッター・セッター
  get inputValue(): string {
    return this.value
  }
  set inputValue(value: string) {
    this.$emit('input', value)
  }

  private get setStyle(): { [key: string]: string } {
    return {
      '--popup-body-top': `${this.topDistance}px`,
      '--popup-body-side': `${this.sideDistance}px`,
    }
  }

  // 要素の高さを入力欄の最大幅に設定
  private mounted() {
    this.maxWidth = this.inputField.clientHeight
  }

  // 入力ポップアップを表示
  private showPopup() {
    this.setPositions()
    this.isShowPopup = true
    // テキストフィールドにフォーカスする
    this.$nextTick(() => {
      this.textFieldStudy.focus()
    })
  }

  /**
   * 入力内容表示部が画面全体の左右どちらにあるのか判定
   * 左の場合は入力ポップアップを表示部の左上端に、右の場合は右上端に合わせて表示
   */
  private setPositions() {
    const clientWidth = document.documentElement.clientWidth
    const triggerRect = this.displayValue.getBoundingClientRect()
    this.topDistance = triggerRect.top
    if (triggerRect.left + triggerRect.width / 2 < clientWidth / 2) {
      this.sidePosition = 'left'
      this.sideDistance = triggerRect.left
    } else {
      this.sidePosition = 'right'
      this.sideDistance = clientWidth - triggerRect.right
    }
  }

  // 入力ポップアップを閉じる
  private hidePopup() {
    this.isShowPopup = false
  }
}
</script>

<style lang="stylus" scoped>
.input-text-field-vertical
  position relative

  &__display
    display flex
    align-items center
    flex-direction row
    flex-wrap wrap

    &__text-before
      margin-bottom 5px

    &__value
      overflow-x auto
      overflow-y hidden
      line-break anywhere
      min-width var(--input-height-default)
      min-height 156px
      padding 4px
      border 1px solid var(--color-default__border)
      border-radius 4px

    &__text-after
      margin-top 5px

  &__popup
    display none
    writing-mode horizontal-tb

    &__background
      position fixed
      left 0
      top 0
      z-index 100
      width 100%
      height 100%
      background-color var(--color-study-input-popup__background)
      opacity 0.6

    &__body
      position fixed
      top var(--popup-body-top)
      z-index 200
      padding 20px
      background-color var(--color-default__box-background)
      border 1px solid var(--color-default__border)
      border-radius 4px
      &[data-side='left']
        left var(--popup-body-side)
      &[data-side='right']
        right var(--popup-body-side)

    &[data-show='true']
      display block
</style>
